import { render } from "./GoodsBar.vue?vue&type=template&id=7c97029e&scoped=true"
import script from "./GoodsBar.vue?vue&type=script&lang=js"
export * from "./GoodsBar.vue?vue&type=script&lang=js"

import "./GoodsBar.vue?vue&type=style&index=0&id=7c97029e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c97029e"]])

export default __exports__